export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg
    viewBox="0 0 64 64"
    fill="none"
    className={`${className} text-ivory`}
    aria-hidden="true"
  >
    <path d="M32 10 L52 54" stroke="currentColor" strokeWidth="3" strokeLinecap="square" />
    <path d="M32 10 L12 54" stroke="currentColor" strokeWidth="3" strokeLinecap="square" />
    <path
      d="M21 38 H43"
      stroke="rgb(var(--c-gold))"
      strokeWidth="3"
      strokeLinecap="square"
    />
    <circle cx="32" cy="38" r="3" fill="rgb(var(--c-gold))" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3" data-testid="site-logo">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-serif text-lg font-semibold tracking-[0.22em] text-ivory">
        ALMALEX
      </span>
      <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.34em] text-gold">
        Legal Consulting
      </span>
    </span>
  </span>
);
